module.exports = __webpack_public_path__ + "static/media/AMX-Regular.197ef91d.ttf";